/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {AdminMenuItem} from './AdminMenuItem'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import { UserModel } from '../../modules/auth/models/UserModel'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import { USER_TYPES } from '../../../utils'

export function AdminMenuMain() {
  let user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel  
  const intl = useIntl()
  const isAdminUser = user?.userRoles?.includes(USER_TYPES.ADMIN)
  const isCustomer = user?.userRoles?.includes(USER_TYPES.CUSTOMER)

  return (
    <>
      {!isCustomer && 
        <AdminMenuItem
          to='/admin/orders'
          title={intl.formatMessage({id: 'MENU.ORDERS'})}
          fontIcon='bi-app-indicator'
          icon='/media/icons/duotune/art/art002.svg'
        />
      }

      {isCustomer && 
        <AdminMenuItem
          to='/customer/dashboard'
          title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
          fontIcon='bi-app-indicator'
          icon='/media/icons/duotune/art/art002.svg'
        />
      }

      {isCustomer && 
        <AdminMenuItem
          to='/customer/orders'
          title={intl.formatMessage({id: 'MENU.MYORDERS'})}
          fontIcon='bi-app-indicator'
          icon='/media/icons/duotune/art/art002.svg'
        />
      }

      {isCustomer && 
        <AdminMenuItem
          to='/customer/quick-order'
          title={intl.formatMessage({id: 'MENU.QUICKORDER'})}
          fontIcon='bi-app-indicator'
          icon='/media/icons/duotune/art/art002.svg'
        />
      }

      {isAdminUser && 
        <AsideMenuItemWithSub
          to='#'
          icon='/media/icons/duotune/art/art002.svg'
          title={intl.formatMessage({id: 'MENU.LOOKUPTABLES'})}
          fontIcon='fa-cog'
        >
          <AdminMenuItem
            to='/admin/lookup-tables/post-code-matrix'
            title='Post Code Matrix'
            fontIcon='bi-app-indicator'
            icon='/media/icons/duotune/art/art002.svg'
          />
          <AdminMenuItem
            to='/admin/lookup-tables/regions'
            title='Regions'
            fontIcon='bi-app-indicator'
            icon='/media/icons/duotune/art/art002.svg'
          />
          <AdminMenuItem
            to='/admin/lookup-tables/topographical-classification-matrix'
            title='Topographical Classification Matrix'
            fontIcon='bi-app-indicator'
            icon='/media/icons/duotune/art/art002.svg'
          />

          <AdminMenuItem
            to='/admin/lookup-tables/wind-classification'
            title='Wind Classification'
            fontIcon='bi-app-indicator'
            icon='/media/icons/duotune/art/art002.svg'
          />
          <AdminMenuItem
            to='/admin/lookup-tables/load-capacity-matrix'
            title='Load Capacity Matrix'
            fontIcon='bi-app-indicator'
            icon='/media/icons/duotune/art/art002.svg'
          />
          <AdminMenuItem
            to='/admin/lookup-tables/span-matrix'
            title='Span Matrix'
            fontIcon='bi-app-indicator'
            icon='/media/icons/duotune/art/art002.svg'
          />
          <AdminMenuItem
            to='/admin/lookup-tables/beam-uplift-loads-matrix'
            title='Beam Uplift Loads Matrix'
            fontIcon='bi-app-indicator'
            icon='/media/icons/duotune/art/art002.svg'
          />
        </AsideMenuItemWithSub>
      }
      {isAdminUser && 
        <AdminMenuItem
          to='/admin/products'
          title={intl.formatMessage({id: 'MENU.PRODUCTS'})}
          fontIcon='bi-app-indicator'
          icon='/media/icons/duotune/art/art002.svg'
        />
      }
      {isAdminUser && 
        <AdminMenuItem
          to='/admin/colours'
          title={intl.formatMessage({id: 'MENU.COLOURS'})}
          fontIcon='bi-app-indicator'
          icon='/media/icons/duotune/art/art002.svg'
        />
      }
    </>
  )
}
